export const decodeId = (idKoob) => {
  if (!idKoob) {
    return null;
  }
  try {
    const result = parseInt(idKoob);
    if (!isNaN(result)) {
      return result;
    }
  } catch (e) {
    return null;
  }
  const decoded = atob(idKoob.replace('\n', ''));
  return parseInt(decoded.substring(decoded.lastIndexOf('/') + 1));
};
